import React, {PropTypes} from 'react';
import FilterPanel from './FilterPanel';
import SearchResult from './SearchResult';
import Loader from 'react-loader';
import {FormattedMessage} from 'react-intl';
import Pagination from 'react-js-pagination';

function customItemsSort(items) {
  let results = [];
  let articles = [];
  let annotations = [];
  items.forEach(item => {
    if (item.attributes.model_type === 'article') {
      articles.push(item);
    }
    else {
      annotations.push(item);
    }
  });
  // articles.sort(function (a, b) {
  //   return a.attributes.order < b.attributes.order ? -1 : 1;
  // });
  // articles.sort(function (a, b) {
  //   return (a.relationships.publication.data[0].id > b.relationships.publication.data[0].id) ? 1 : ((b.relationships.publication.data[0].id > a.relationships.publication.data[0].id) ? -1 : 0);
  // });
  return results.concat(articles, annotations);
}

class SearchResults extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.perPage = 10;
  }

  render() {
    let {perPage} = this;
    let {items, isFetching, initial, changePage, page, meta, intl} = this.props;
    if (initial) {
      return null;
    }
    if (!items || isFetching) {
      return (<Loader loaded={false}/>);
    }
    let totalItems = meta && meta.count || 0;
    let start = (page - 1) * perPage;
    let end = Math.min(page * perPage, totalItems);
    let resultNodes = items.map(function (item) {
      return (
        <SearchResult item={item} key={item.id}/>
      );
    });
    let synonymlabels = meta && meta.synonyms || null;
    let synonyms = null;
    if (synonymlabels && synonymlabels.length > 0) {
      synonyms = [];
      synonymlabels.forEach((syn, index) => {
        if (index > 0) {
          if (index < synonymlabels.length - 1) {
            synonyms.push(', ');
          }
          else {
            synonyms.push(' ' + intl.messages.or + ' ');
          }
        }
        synonyms.push(<em>{syn}</em>);
      });
    }

    return (<div>
      <FilterPanel/>
      <hr/>
      <h2><FormattedMessage id="searchResults" values={{results: totalItems}}/>{totalItems > perPage ?
        <small>&nbsp;<FormattedMessage id="showingXofY" values={{start: start + 1, end}}/></small> : null}</h2>
      {synonyms ? <p><FormattedMessage id="alsoLookedFor"/>: {synonyms}</p> : null}
      {/*{items.length >= 999 ? <p><FormattedMessage id="tooManyResults"/></p> : null}*/}
      {totalItems > perPage ?
        (<Pagination
          activePage={page}
          itemsCountPerPage={10}
          totalItemsCount={totalItems}
          pageRangeDisplayed={5}
          onChange={changePage}
        />) : null
      }
      {resultNodes}
      {totalItems > perPage ?
        (<Pagination
          activePage={page}
          itemsCountPerPage={10}
          totalItemsCount={totalItems}
          pageRangeDisplayed={5}
          onChange={changePage}
        />) : null
      }
    </div>);
  }
}

SearchResults.propTypes = {
  items: PropTypes.array,
  meta: PropTypes.object,
  intl: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  initial: PropTypes.bool.isRequired,
  page: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired
};

SearchResult.defaultProps = {
  items: [],
  meta: {
    count: 0
  },
  intl: {
    or: 'or'
  }
};

export default SearchResults;



/** WEBPACK FOOTER **
 ** ./src/modules/search/components/SearchResults.js
 **/